import { UrlMatchResult, UrlSegment, UrlMatcher } from '@angular/router';

/** Single-segment paths that are exactly 6 chars but are not Firestore short-link IDs. */
const RESERVED_SIX_CHAR_SEGMENTS = new Set(['invite']);

/**
 * Matches `/XXXXXX` where `XXXXXX` is a 6-character alphanumeric short id (deferred link),
 * so the admin SPA can handle short URLs the same as `/invite/:shortId` instead of falling
 * through to `**` → `/index` (which drops the id before dynamic-link handling runs).
 */
export const adminShortInviteLinkMatcher: UrlMatcher = (segments: UrlSegment[]): UrlMatchResult | null => {
  if (segments.length !== 1) {
    return null;
  }
  const path = segments[0].path;
  if (path.length !== 6 || !/^[A-Za-z0-9]{6}$/.test(path)) {
    return null;
  }
  if (RESERVED_SIX_CHAR_SEGMENTS.has(path.toLowerCase())) {
    return null;
  }
  return { consumed: segments };
};
